var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bd-cell-item flex-r-cc"},[(_vm.item.type == 0)?_c('div',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.item.value)}}):_vm._e(),_vm._v(" "),(_vm.item.type == 2)?_c('div',[_c('i',{staticClass:"iconfont iconduigou"})]):_vm._e(),_vm._v(" "),(_vm.item.type == 1)?_c('div',[_c('i',{staticClass:"iconfont iconcuowu"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/bd-cell/bd-cell-item.vue?vue&type=template&id=6bb3e57a&scoped=true
// module id = null
// module chunks = 